export default __webpack_public_path__ + "static/media/image6.ef73bf38.jpg";